import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-my-change-password',
  templateUrl: './admin-my-change-password.component.html',
  styleUrls: ['./admin-my-change-password.component.sass'],
  standalone: false
})
export class AdminMyChangePasswordComponent implements OnInit {

  constructor() { }
  title = 'Change Password';
  ngOnInit() {
  }

}
